const isTrafficOrPower = (key) => {
  return (
    (key?.toLowerCase()?.includes("inoctets") ||
      key?.toLowerCase()?.replace(/_/g, "")?.includes("rxpower") ||
      key?.toLowerCase()?.includes("outoctets") ||
      key?.toLowerCase()?.replace(/_/g, "")?.includes("txpower")) &&
    !key?.toLowerCase()?.includes("_olt")
  );
};
export default isTrafficOrPower;
